import React, { useEffect, useState } from "react";
import SubContenidoTemario from "../SubContenidoTemario/SubContenidoTemario";

export default function SubTemarioTarjeta({ vArrSecciones = [] }) {
  
  const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 479);
      };
  
      checkScreenSize(); // Verifica al cargar
  
      window.addEventListener("resize", checkScreenSize); // Escucha cambios
  
      return () => {
        window.removeEventListener("resize", checkScreenSize); // Limpia al desmontar
      };
    }, []);
  
    const imageName = isMobile
      ? "icon_estudiante_blanco.svg"
      : "icon_estudiante_negro.svg";

  return (
    <div data-figma-id="4378:18449" class="temario-2">
      <div data-figma-id="4372:18325" class="temario-titulo">
        <p data-figma-id="4372:18326" class="temario-titulo-texto-2">
          Temario
        </p>
      </div>
      <div data-figma-id="4372:18327" class="temario-linea-divisora"></div>
      {vArrSecciones.map((vArrSecciones, vIndice) => (
        <SubContenidoTemario
          vNumSeccion={vIndice + 1}
          vTituloSeccion={vArrSecciones.nombre}
          vContenidoSeccion={vArrSecciones.resumen}
        />
      ))}
      <div data-figma-id="4372:18357" className="temario-seccion-2">
        <img
          src={`${window.location.origin}/images/${imageName}`}
          alt="Icono de credencial"
          loading="lazy"
          className="img-27"
        />
        <div data-figma-id="4372:18360" className="frame-289784">
          <p
            data-figma-id="4372:18361"
            className="certificado-de-finalizaci-n-disponible"
          >
            Certificado de finalización disponible
          </p>
          <p
            data-figma-id="4372:18362"
            className="obt-n-un-certificado-de-finalizaci-n-y-muestra-tus-logros"
          >
            Obtén un certificado de finalización y muestra tus logros
          </p>
        </div>
      </div>
    </div>
  );
}
